import createRequest from 'utils/request.ts';

export type Promotion = {
  action_url: string;
  cover_image_url: string;
  full_content: string | TrustedHTML;
  id: number;
  image_url: string;
  mobile_cover_image_url: string;
  mobile_image_url: string;
  order_position: number;
  short_content: string;
  title: string;
};

type PromotionsRequestParams = {
  query: {
    lang: string;
  };
};

export const promotionsRequest = createRequest<
  Array<Promotion>,
  PromotionsRequestParams
>('/api/cms-go/v2/site/promotion/list');
